import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  setSortFieldTypesPublipostages,
  setOrderTypesPublipostages,
  setCurrentPageTypesPublipostages,
  setValueTypesPublipostages,
  setCategorieTypesPublipostages,
  setAccesInvestisseurTypesPublipostages,
  setAccesCgpTypesPublipostages,
} from "../../store/actions";
import ReactPaginate from "react-paginate";
import { useSelector, useDispatch } from "react-redux";
import { Col, Row, Card, CardBody } from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import useDebounce from "./useDebounce";
import { useNavigate } from "react-router-dom";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonList";
import LastModificationAlert from "components/Common/Alert";

function TypesPublipostages() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [listData, setListData] = useState([]);
  const token = localStorage.getItem("auth_token_" + api);

  const currentPage = useSelector(
    (state) => state.FiltreTypesPublipostages.currentPage
  );
  const itemsPerPage = 20;

  const value = useSelector(
    (state) => state.FiltreTypesPublipostages.value
  );
  const categorie = useSelector(
    (state) => state.FiltreTypesPublipostages.categorie
  );
  const accesInvestisseur = useSelector(
    (state) => state.FiltreTypesPublipostages.accesInvestisseur
  );
  const accesCgp = useSelector(
    (state) => state.FiltreTypesPublipostages.accesCgp
  );
  const debounceSearch = useDebounce(value, 500);

  const sortField = useSelector(
    (state) => state.FiltreTypesPublipostages.sortField
  );
  const order = useSelector(
    (state) => state.FiltreTypesPublipostages.order
  );
  const [isSorting, setIsSorting] = useState(false);

  const buildUrl = (page, sf, o, key, cat, inv, cgp) =>
    `https://www.fluxod.com/${api}/types_publipostages?page=${page}&sort_by=${sf}_${o}&key=${key ?? ""}&categories_document=${cat ?? ""}&acces_investisseur=${inv ?? ""}&acces_cgp=${cgp ?? ""}`;

  const handleSorting = async (sortFieldVal, sortOrder) => {
    try {
      const response = await fetch(
        buildUrl(1, sortFieldVal, sortOrder, debounceSearch, categorie, accesInvestisseur, accesCgp),
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const newData = await response.json();
      setListData(newData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const handleSortingChange = (accessor) => {
    dispatch(setCurrentPageTypesPublipostages(1));
    setIsSorting(true);
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";
    dispatch(setSortFieldTypesPublipostages(accessor));
    dispatch(setOrderTypesPublipostages(sortOrder));
    handleSorting(accessor, sortOrder);
    setIsSorting(false);
  };

  document.title = "Type doc fusion | DOM COM";

  useEffect(() => {
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);

  const fetchPage = async (page) => {
    try {
      const res = await fetch(
        buildUrl(page, sortField, order, debounceSearch, categorie, accesInvestisseur, accesCgp),
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Error fetching page: ", error);
    }
  };

  const handlePageChange = async (data) => {
    let page = data.selected + 1;
    const getData = await fetchPage(page);
    dispatch(setCurrentPageTypesPublipostages(page));
    setListData(getData);
  };

  const handleFilterChange = (accessor, val) => {
    const updatedFilters = listData.filters.map((filter) => {
      if (filter.accessor === accessor) {
        return { ...filter, value: val };
      }
      return filter;
    });
    setListData((prevData) => ({ ...prevData, filters: updatedFilters }));
  };

  const renderFilters = () => {
    return (
      <>
        {!loading ? (
          <>
            {listData?.filters?.map((filter, index) => {
              switch (filter.accessor) {
                case "key":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <input
                        defaultValue={value}
                        className="form-control mb-3 mb-xxl-0"
                        type="text"
                        placeholder={filter.label}
                        onChange={(e) => {
                          dispatch(setValueTypesPublipostages(e.target.value));
                          dispatch(setCurrentPageTypesPublipostages(1));
                          handleFilterChange(filter.accessor, e.target.value);
                        }}
                      />
                    </Col>
                  );
                case "categories_document":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        value={categorie}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(
                            setCategorieTypesPublipostages(e.target.value)
                          );
                          dispatch(setCurrentPageTypesPublipostages(1));
                          handleFilterChange(filter.accessor, e.target.value);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                case "acces_investisseur":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        value={accesInvestisseur}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(
                            setAccesInvestisseurTypesPublipostages(e.target.value)
                          );
                          dispatch(setCurrentPageTypesPublipostages(1));
                          handleFilterChange(filter.accessor, e.target.value);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        <option value="1">Oui</option>
                        <option value="2">Non</option>
                      </select>
                    </Col>
                  );
                case "acces_cgp":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        value={accesCgp}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(
                            setAccesCgpTypesPublipostages(e.target.value)
                          );
                          dispatch(setCurrentPageTypesPublipostages(1));
                          handleFilterChange(filter.accessor, e.target.value);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        <option value="1">Oui</option>
                        <option value="2">Non</option>
                      </select>
                    </Col>
                  );
                default:
                  return null;
              }
            })}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetch(
          buildUrl(currentPage, sortField, order, debounceSearch, categorie, accesInvestisseur, accesCgp),
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.status === 403) navigate(`${backUrl}/forbidden`);
        if (response.status === 500) navigate(`${backUrl}/error`);
        if (response.status === 203) navigate(`${backUrl}/error404`);
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        const newData = await response.json();
        setListData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [debounceSearch, categorie, accesInvestisseur, accesCgp]);

  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);

  return (
    <React.Fragment>
      <div className="page-content">
        {previousPath ===
        `${backUrl}/types_publipostages/${lastId}/edit` ? (
          <LastModificationAlert path={"types_publipostages"} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title text-primary flex-grow-1">
                      Type doc fusion (
                      {loading ? "--" : listData?.total_records})
                    </h5>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <Link
                        to={`${backUrl}/types_publipostages/new`}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="bx bx-plus"></i>Ajouter
                      </Link>
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {!loading ? (
                    <>
                      <Row className="mb-3">{renderFilters()}</Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="table-responsive">
                    {!loading ? (
                      <>
                        <table className="table">
                          <thead>
                            <tr>
                              {listData?.can_edit === false &&
                              listData?.can_show === false &&
                              listData?.can_destroy === false ? (
                                <th></th>
                              ) : (
                                <th
                                  style={{ cursor: "default" }}
                                  key="Action"
                                  className="text"
                                >
                                  Action
                                </th>
                              )}
                              {listData?.headers
                                ?.filter((h) => h.visible !== false)
                                ?.map(({ header, accessorKey, sortable }) => {
                                  const cl = sortable ? (
                                    sortField === accessorKey ? (
                                      order === "asc" ? (
                                        <i className="bx bx-up-arrow-alt"></i>
                                      ) : (
                                        <i className="bx bx-down-arrow-alt"></i>
                                      )
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  );
                                  return (
                                    <th
                                      key={accessorKey}
                                      onClick={
                                        sortable
                                          ? () =>
                                              handleSortingChange(accessorKey)
                                          : null
                                      }
                                      className="text-nowrap"
                                      style={{
                                        cursor: sortable ? "pointer" : "default",
                                      }}
                                    >
                                      {header}
                                      {cl}
                                    </th>
                                  );
                                })}
                            </tr>
                          </thead>
                          <tbody>
                            {listData?.data?.map((rowData, rowIndex) => (
                              <tr key={rowIndex}>
                                <td>
                                  <ul className="list-unstyled hstack gap-1 mb-0">
                                    {listData?.can_show ? (
                                      <li
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Voir"
                                      >
                                        <Link
                                          className="btn btn-sm btn-soft-primary"
                                          to={`${backUrl}/types_publipostages/${rowData.id}`}
                                        >
                                          <i className="mdi mdi-eye-outline"></i>
                                        </Link>
                                      </li>
                                    ) : null}
                                    {listData?.can_edit ? (
                                      <li title="Editer">
                                        <Link
                                          className="btn btn-sm btn-soft-info"
                                          to={`${backUrl}/types_publipostages/${rowData.id}/edit`}
                                          state={{ active: "details" }}
                                        >
                                          <i className="mdi mdi-pencil-outline"></i>
                                        </Link>
                                      </li>
                                    ) : null}
                                    {listData?.can_destroy ? (
                                      <li title="Supprimer">
                                        <DeleteButton
                                          url={`https://www.fluxod.com/${api}/types_publipostages/${rowData.id}`}
                                        />
                                      </li>
                                    ) : null}
                                  </ul>
                                </td>
                                {listData?.headers
                                  ?.filter((h) => h.visible !== false)
                                  ?.map(
                                    ({ accessorKey, type: colType }) => (
                                      <React.Fragment
                                        key={`${rowIndex}-${accessorKey}`}
                                      >
                                        {colType === "link" &&
                                        rowData[accessorKey] != null ? (
                                          <td
                                            style={{
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                          >
                                            <a
                                              href={rowData[accessorKey]}
                                              target="_blank"
                                              rel="noreferrer"
                                            >
                                              <i
                                                style={{
                                                  fontSize: "25px",
                                                  paddingLeft: "8px",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                }}
                                                className="bx bx-download"
                                              ></i>
                                            </a>
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                          >
                                            {rowData[accessorKey] ?? "——"}
                                          </td>
                                        )}
                                      </React.Fragment>
                                    )
                                  )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <Spinners setLoading={setLoading} setWait={400} />
                    )}
                  </div>
                </CardBody>
                <div className="d-flex justify-content-center mt-3">
                  {!loading ? (
                    <ReactPaginate
                      previousLabel={"<<"}
                      breakLabel={"..."}
                      nextLabel={">>"}
                      pageCount={listData.pages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={currentPage - 1}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}

export default TypesPublipostages;
